import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useProject } from '../contexts/ProjectContext';
import api from '../utils/api';

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const { projects, currentProject, setCurrentProject } = useProject();
  const location = useLocation();
  const initials = user?.email ? user.email.slice(0, 2).toUpperCase() : '??';

  // Which build is live. Stamped at deploy time, so it reflects the files that
  // were actually copied in — not whatever the image happened to be built from.
  const [version, setVersion] = useState(null);
  useEffect(() => {
    api.get('/api/version').then(r => setVersion(r.data)).catch(() => {});
  }, []);

  const versionLabel = version
    ? `${version.commit}${version.dirty ? '+local' : ''}`
    : '';
  const versionTitle = version
    ? [
        `commit ${version.commit}${version.branch ? ` (${version.branch})` : ''}`,
        version.committed_at ? `committed ${new Date(version.committed_at).toLocaleString()}` : null,
        version.deployed_at ? `deployed ${new Date(version.deployed_at).toLocaleString()}` : null,
        version.dirty ? 'DEPLOYED WITH UNCOMMITTED CHANGES — the commit does not describe what is running' : null,
      ].filter(Boolean).join('\n')
    : '';

  return (
    <>
      <nav className="nav">
        <Link to="/" className="nav-logo">
          <span style={{ color: 'white' }}>emew</span>
          <span className="accent"> Voltage Analytics</span>
        </Link>

        {versionLabel && (
          <span
            title={versionTitle}
            style={{
              marginLeft: 10,
              padding: '2px 7px',
              borderRadius: 10,
              fontSize: 10,
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
              letterSpacing: 0.3,
              cursor: 'help',
              whiteSpace: 'nowrap',
              // Amber when the deploy carried uncommitted changes: the commit
              // hash alone then doesn't tell you what's actually running.
              color: version?.dirty ? '#7a4a00' : 'rgba(255,255,255,0.75)',
              background: version?.dirty ? '#ffd479' : 'rgba(255,255,255,0.12)',
            }}
          >
            {versionLabel}
          </span>
        )}

        {/* Project switcher */}
        {projects.length > 0 && (
          <div className="nav-project-select">
            <select
              value={currentProject?.id ?? ''}
              onChange={e => {
                const p = projects.find(p => p.id === parseInt(e.target.value, 10));
                if (p) setCurrentProject(p);
              }}
            >
              {projects.map(p => (
                <option key={p.id} value={p.id}>{p.name}</option>
              ))}
            </select>
          </div>
        )}

        <div className="nav-spacer" />
        <Link
          to="/"
          className={`nav-link${location.pathname === '/' ? ' active' : ''}`}
        >
          Dashboard
        </Link>
        {user?.is_admin && (
          <Link
            to="/admin"
            className={`nav-link${location.pathname === '/admin' ? ' active' : ''}`}
          >
            Admin
          </Link>
        )}
        <div className="nav-user">
          <div className="nav-avatar">{initials}</div>
          <span style={{ fontSize: 12 }}>{user?.email}</span>
          <button className="nav-sign-out" onClick={logout}>Sign out</button>
        </div>
      </nav>
      <main className="main-content">{children}</main>
    </>
  );
}
